import { MenuList } from '@mui/material';
import React from 'react';

import { DATA_TEST } from '../../enums';
import { ISwitchMenuItem } from '../../types';

import { PopperSubmenuContainer } from '../PopperSubmenuContainer';
import { delayedMobileCloseClickHandler } from '../utils';

import { SwitchMenuItem } from './SwitchMenuItem';

interface ISwitchSubmenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  switchMenuItems: ISwitchMenuItem[];
  firstSwitchInputRef?: React.MutableRefObject<HTMLInputElement>;
  handleClose(): void;
}
export const SwitchSubmenu: React.FC<ISwitchSubmenuProps> = ({
  anchorEl,
  open,
  handleClose,
  switchMenuItems,
  firstSwitchInputRef
}) => {
  const containerRef = React.useRef<HTMLUListElement>(null);

  return (
    <PopperSubmenuContainer
      anchorEl={anchorEl}
      open={open}
      disablePortal={true}
      dataTest={DATA_TEST.switch_menu_submenu}
      positionOffset={{ x: 0, y: 3 }}
      handleClose={() => {
        // The MUI ClickAwayListener callback resists testing efforts...
        // Omitting it from test coverage for now
        /* istanbul ignore next */
        delayedMobileCloseClickHandler(handleClose);
      }}
    >
      <MenuList
        ref={containerRef}
        aria-labelledby="switch-menu-button"
        id="switch-menu-submenu"
        sx={{
          width: 350,
          p: 1
        }}
      >
        {switchMenuItems.map((item: ISwitchMenuItem, index: number) => (
          <SwitchMenuItem
            parentContainerRef={containerRef}
            switchLabel={item.switchLabel}
            key={item.title}
            title={item.title}
            description={item.description}
            value={item.value}
            onValueChange={item.onValueChange}
            dataOG={item.dataOG}
            autoFocus={index === 0}
            firstSwitchInputRef={index === 0 ? firstSwitchInputRef : null}
            anchorEl={anchorEl}
            requiresOgAssistPermission={item.requiresOgAssistPermission}
          />
        ))}
      </MenuList>
    </PopperSubmenuContainer>
  );
};
